import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=bcb4d2c8"
import script from "./navigation.vue?vue&type=script&lang=js"
export * from "./navigation.vue?vue&type=script&lang=js"
import style0 from "./navigation.vue?vue&type=style&index=0&id=bcb4d2c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports